// Court Vibes, kleine Verbesserungen an Warenkorb und Kontaktformular.
//
// TEIL 1, 06.09.2026: Knopf "Weiter einkaufen" im leeren Warenkorb.
//
// Ab Werk ist der Knopf ein Link auf die Kollektion mit allen Produkten. Steht der
// Warenkorb als Schublade ueber einer Produktseite, reisst dieser Link den Kunden von
// der Seite weg, und bei personalisierten Produkten ist damit auch die ganze Eingabe
// verloren, also Name, Farbe und hochgeladenes Logo.
//
// Neues Verhalten:
//   Knopf steht in der Schublade -> Schublade schliessen, die Seite darunter bleibt.
//   Knopf steht auf der Warenkorbseite -> auf die Startseite, nicht auf "Alle Produkte".
//
// Drei Punkte, alle am 06.09.2026 im Browser gemessen:
// 1. Der Klick wird am Dokument abgefangen, weil das Theme den leeren Zustand neu
//    zeichnet und ein direkt gebundener Listener dabei verloren ginge.
// 2. Geschlossen wird ueber den vorhandenen X-Knopf des Themes. Ein direkter Aufruf von
//    close() oder closeDialog() am cart-drawer-component bleibt wirkungslos.
// 3. Der Klick auf den X-Knopf muss in setTimeout stehen. Direkt im laufenden
//    Klick-Handler ausgeloest, verpufft er.
//
// Geprueft wird nur, OB der Knopf in einem dialog steht, nicht ob dialog.open true ist.
// Das open-Attribut hinkt beim Oeffnen der Schublade kurz nach.
(function () {
  document.addEventListener('click', function (e) {
    var ziel = e.target;
    if (!ziel || !ziel.closest) return;
    var knopf = ziel.closest('.cart-items__empty-button');
    if (!knopf) return;

    var dialog = knopf.closest('dialog');
    if (dialog) {
      e.preventDefault();
      var schliessen = dialog.querySelector('[ref="closeButton"], .cart-drawer__close-button');
      setTimeout(function () {
        if (schliessen) schliessen.click();
        else if (dialog.open) dialog.close();
      }, 0);
      return;
    }

    e.preventDefault();
    var start = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      start = window.Shopify.routes.root;
    }
    window.location.href = start;
  });
})();

// TEIL 2, 06.09.2026: Bestaetigung nach dem Absenden des Kontaktformulars.
//
// Das Theme zeigt nach dem Absenden bereits eine Bestaetigung, den Satz
// "Danke, dass du uns kontaktiert hast..." mit einem Haken davor. Er steht aber als
// duenne graue Zeile direkt ueber dem Namensfeld und geht neben dem langen Text
// darueber komplett unter. Houda hat ihn beim Testen nicht bemerkt.
//
// Diese Ergaenzung macht daraus einen sichtbaren gruenen Kasten, scrollt ihn in den
// Blick und leert die Felder, damit klar ist, dass die Nachricht weg ist.
//
// Warum das Aussehen hier aus JavaScript kommt und nicht aus assets/cv-extra.css:
// diese Datei ist klein, cv-extra.css hat rund 7.700 Zeichen und muesste jedes Mal
// komplett neu geschrieben werden. Die Bestaetigung erscheint ausserdem nur nach einem
// Seitenwechsel, ein kurzes Aufblitzen ist dort ohne Bedeutung.
(function () {
  function los() {
    var box = document.querySelector('.contact-form__success');
    if (!box) return;

    var stil = document.createElement('style');
    stil.textContent =
      '.contact-form .contact-form__success{' +
      'align-items:flex-start;gap:10px;' +
      'padding:16px 20px;margin-block-end:8px;' +
      'border:1px solid #2e4a29;border-radius:12px;' +
      'background:#eef1ea;color:#091208;' +
      'font-weight:600;line-height:1.4;' +
      'scroll-margin-block-start:140px;}' +
      '.contact-form .contact-form__success svg{flex:none;width:20px;height:20px;margin-top:2px;}';
    document.head.appendChild(stil);

    // Felder leeren, sonst sieht es aus, als waere die Nachricht noch nicht raus.
    var felder = document.querySelectorAll('.contact-form__input');
    for (var i = 0; i < felder.length; i++) felder[i].value = '';

    try {
      box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } catch (err) {
      box.scrollIntoView();
    }
  }

  if (document.readyState !== 'loading') los();
  else document.addEventListener('DOMContentLoaded', los);
})();
